export default __webpack_public_path__ + "static/media/info-outline.82df3587.svg";